import React, { useState, useEffect } from 'react';
import ColorPopup from './ColorPopup.js';
import FontGlyphDialog from './FontGlyphDialog.js';
import SvgGlyphDialog from './SvgGlyphDialog.js';

const SettingsDialog = ({ isOpen, onClose, onSave, rectData, segments, aSegment, lines, onScrollOpen}) => {

  const [strokeColor, setStrokeColor] = useState("#000000");
  const [strokeWidth, setStrokeWidth] = useState(2);

  const [fillColor, setFillColor] = useState("#ffffff");
  const [alpha, setAlpha] = useState(1);
  const [bAlpha, setBAlpha] = useState(1);

  const [allowStroke, setAllowStroke] = useState(true);
  const [allowFill, setAllowFill] = useState(false);

  const [yourText, setYourText] = useState("Default Text");
  const [font, setFont] = useState("Roboto-BlackItalic.ttf");

  const [cornerTL, setCornerTL] = useState(0);
  const [cornerTR, setCornerTR] = useState(0);
  const [cornerBR, setCornerBR] = useState(0);
  const [cornerBL, setCornerBL] = useState(0);

  const [fillMode, setFillMode] = useState("solid"); // "solid" | "gradient"
  const [gradientColor1, setGradientColor1] = useState("#ffffff");
  const [gradientColor2, setGradientColor2] = useState("#000000");
  const [gradientAngle, setGradientAngle] = useState(0);

  const supportsCorners =
    rectData &&
    (rectData.subType === "SvgRect" || rectData.subType === "SvgSquare" || rectData.type === "Group");

  const backgroundAlphaSupported = 
    rectData && rectData.type === "Group";

  const isSvgText = rectData &&  rectData.type === "SvgText";

  useEffect(() => {
    if (rectData)
    {

        if(rectData.type === 'Bezier' || rectData.type === 'Prect')
        {
          let p =  rectData.path;

          if(p.length === 1)
          {
              let l = p[0];
              
              rectData.strokeColor =  l?.strokeColor;
              rectData.strokeWidth = l?.strokeWidth;
              rectData.fillColor = l?.fillColor;
              rectData.fillAlpha = l?.alpha;
              rectData.allowStroke = l?.allowStroke;
              rectData.allowFill = l?.allowFill;
              rectData.fillMode = l?.fillMode;
              rectData.gradientColor1 = l?.gradientColor1;
              rectData.gradientColor2 = l?.gradientColor2;
              rectData.gradientAngle = l?.gradientAngle;
          }
          else
          {
            rectData.fillAlpha = 1;
          }
        }

        setStrokeColor(rectData.strokeColor);
        setStrokeWidth(rectData.strokeWidth);
        setFillColor(rectData.fillColor);
        setAlpha(rectData.fillAlpha);
        setBAlpha(rectData.bAlpha);
      
        setFillMode(rectData.fillMode);
        setGradientColor1(rectData.gradientColor1);
        setGradientColor2(rectData.gradientColor2);
        setGradientAngle(rectData.gradientAngle);

        setAllowStroke(rectData.allowStroke);
        setAllowFill(rectData.allowFill);

        setCornerTL(rectData.cornerTL || 0);
        setCornerTR(rectData.cornerTR || 0);
        setCornerBR(rectData.cornerBR || 0);
        setCornerBL(rectData.cornerBL || 0);

        if(isSvgText)
        {
          setFont(rectData.fontUrl);
          setYourText(rectData.fontText);
        }
      }

  }, [rectData]);

  useEffect(() => {

    if (segments?.length>0)
    {
        console.log("Usinging segments");

        let li=segments[0].lineIndex;
        let line = lines[li];

        setStrokeColor(line?.strokeColor);
        setStrokeWidth(line?.strokeWidth);
        setFillColor(line?.fillColor);
        setAlpha(line?.alpha);

        setAllowStroke(line?.allowStroke);
        setAllowFill(line?.allowFill);
      }

  }, [segments]);




  const handleSave = () => {

    /*
    console.log("Saving");
    if (!allowStroke && !allowFill) {
      alert("At least one of Stroke or Fill must be enabled.");
      return;
    }
    */
    if (rectData) {


      if(rectData.type === 'Bezier' || rectData.type === 'Prect')
      {

        let p =  rectData.path;

        let l = p[0];

        l.strokeColor = strokeColor;
        l.strokeWidth = strokeWidth;
        l.fillColor = fillColor;
        l.alpha = alpha;        
        l.allowStroke = allowStroke;
        l.allowFill = allowFill;
        l.fillMode = fillMode;
        l.gradientColor1 = gradientColor1;
        l.gradientColor2 = gradientColor2;
        l.gradientAngle = gradientAngle;

        if(rectData.subType === 'FreeHand')
        {
          p.forEach((l) =>
          {
            l.strokeColor = strokeColor;
            l.strokeWidth = strokeWidth;
            l.fillColor = fillColor;
            l.alpha = alpha;        
            l.allowStroke = allowStroke;
            l.allowFill = allowFill;
            l.fillMode = fillMode;
            l.gradientColor1 = gradientColor1;
            l.gradientColor2 = gradientColor2;
            l.gradientAngle = gradientAngle;
    
          });
        }
      }

      rectData.strokeColor = strokeColor;
      rectData.strokeWidth = strokeWidth;

      rectData.fillColor = fillColor;
      rectData.fillAlpha = alpha;
      rectData.bAlpha = bAlpha;

      rectData.allowStroke = allowStroke;
      rectData.allowFill = allowFill;

      rectData.fillMode = fillMode;
      rectData.gradientColor1 = gradientColor1;
      rectData.gradientColor2 = gradientColor2;
      rectData.gradientAngle = gradientAngle;


      if (supportsCorners) {
        rectData.cornerTL = Number(cornerTL);
        rectData.cornerTR = Number(cornerTR);
        rectData.cornerBR = Number(cornerBR);
        rectData.cornerBL = Number(cornerBL);
      }

      if(isSvgText)
      {
        rectData.fontUrl = font;
        rectData.fontText = yourText;
      }
    }
    
    onSave({
      strokeColor,
      strokeWidth,
      fillColor,
      alpha,
      bAlpha,
      allowStroke,
      allowFill,
      fillMode,
      gradientColor1,
      gradientColor2,
      gradientAngle,                      
      cornerTL,
      cornerTR,
      cornerBR,
      cornerBL
    });

    console.log("Should Close");
    onClose();
  };


  function getFontTypes() {
    const fontTypes = [
      "Roboto-Regular.ttf",
      "Roboto-Light.ttf",
      "Roboto-Medium.ttf",
      "Roboto-Bold.ttf",
      "Roboto-Black.ttf",
      
      "Roboto-Italic.ttf",
      "Roboto-BoldItalic.ttf",
      
      "Roboto_Condensed-Regular.ttf",
      "Roboto_Condensed-Light.ttf",
      "Roboto_Condensed-Medium.ttf",
      "Roboto_Condensed-Bold.ttf",
      "Roboto_Condensed-Black.ttf",

      "ComicNeue-Light.ttf",
      "ComicNeue-Regular.ttf",
      "ComicNeue-Bold.ttf",
      "ComicNeue-LightItalic.ttf",
      "ComicNeue-Italic.ttf",      
      "ComicNeue-BoldItalic.ttf",
              
      "ComicRelief-Regular.ttf",
      "ComicRelief-Bold.ttf",

      "PlayfairDisplay-Regular.ttf",
      "PlayfairDisplay-Bold.ttf",
      "PlayfairDisplay-Black.ttf",
      "BebasNeue-Regular.ttf",

      "Montserrat-Regular.ttf",
      "Montserrat-Medium.ttf",
      "Montserrat-Bold.ttf",
      "Montserrat-ExtraBold.ttf",
      
      "Lora-Regular.ttf",
      "Lora-Italic.ttf",      
      "Lora-Bold.ttf",
      
      "Oswald-Regular.ttf",
      "Oswald-Medium.ttf",  
      "Oswald-Bold.ttf",  
      
      "Pacifico-Regular.ttf",

      "Satoshi-Light.ttf",         
      "Satoshi-Regular.ttf",
      "Satoshi-Medium.ttf",
      "Satoshi-Bold.ttf",
      "Satoshi-Black.ttf", 

      "Satoshi-Italic.ttf",                   
      "Satoshi-BoldItalic.ttf",  
      
      "NotoSansSymbols2-Regular.ttf"

    ];

    return fontTypes.map((item, idx) => (
      <option key={idx} value={item}>
        {item}
      </option>
    ));
  }


  function setFontCharacters(newStr)
  {
    // alert(newStr);
    setYourText(newStr);
  }

  if (!isOpen) return null;

  let  fontUrl = `https://myaiweb.ca/fonts/static/${font}`;
  return (
    <div style={styles.overlay}>
      <div style={styles.dialog}>

        <h2>Shape Properties</h2>
        {isSvgText && 
          (

            <div>
                <label style={styles.labelFont}>
                Your Text
                <input
                  type="text"
                  maxLength={80}
                  style={styles.input}
                  value={yourText}
                  onChange={(e) => setYourText(e.target.value)}
                  placeholder="Enter up to 80 characters"
                />
              </label>

              <label style={styles.labelFont}>
                Font
                <select
                  style={styles.input}
                  value={font}
                  onChange={(e) => setFont(e.target.value)}
                >
                  {getFontTypes()}
                </select>
              </label>
              <FontGlyphDialog 
                           fontUrl={fontUrl}
                           defaultString = {yourText}
                           onScrollOpen = {onScrollOpen}
                           onGlyphSelected = {(newString) =>{setFontCharacters(newString)}}
              />

            {/*
              <SvgGlyphDialog
                indexUrl="emoji.json"
                svgBaseUrl="https://myaiweb.ca/openmoji"

              />
          */}
              </div>)}


          {/* Stroke Section */}
          <Section title="Stroke">

            <Checkbox
              label="Enable Stroke"
              value={allowStroke}
              onChange={() => setAllowStroke(!allowStroke)}
            />

            <div style={styles.inlineRow}>
              <Field label="Color">
                  <ColorPopup
                      color={strokeColor}
                      onChange={(strokeColor) => setStrokeColor(strokeColor)}
                  />
              </Field>

              <Field label="Width">
                <input
                  type="range"
                  min="1"
                  max="20"
                  disabled={!allowStroke}
                  value={strokeWidth}
                  onChange={(e) => setStrokeWidth(e.target.value)}
                  style={{ width: "100%" }}  
                />
                <span>{strokeWidth}</span>
              </Field>
            </div>

          </Section>


          <Section title="Opacity">
            <Field label="Opacity">
                  <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    value={alpha}
                    onChange={(e) => setAlpha(e.target.value)}
                  />
                  <span>{alpha}</span>
                </Field>

              {backgroundAlphaSupported && (
                  <Field label="Img Opacity">
                    <input
                      type="range"
                      min="0"
                      max="1"
                      step="0.01"
                      value={bAlpha}
                      onChange={(e) => setBAlpha(e.target.value)}
                    />
                    <span>{bAlpha}</span>
                  </Field>
                )}
          </Section>            

          {/* Fill Section */}
          <Section title="Fill">

            <Checkbox
              label="Enable Fill"
              value={allowFill}
              onChange={() => setAllowFill(!allowFill)}
            />

            {allowFill && (
              <>
                {/* Mode */}
                <div style={styles.inlineRow}>
                  <label>
                    <input
                      type="radio"
                      checked={fillMode === "solid"}
                      onChange={() => setFillMode("solid")}
                    />
                    Solid
                  </label>

                  <label>
                    <input
                      type="radio"
                      checked={fillMode === "gradient"}
                      onChange={() => setFillMode("gradient")}
                    />
                    Gradient
                  </label>
                </div>

                {/* SOLID */}
                {fillMode === "solid" && (
                  <Field label="Color">
                      <ColorPopup
                        color={fillColor}
                        onChange={(fillColor) => setFillColor(fillColor)}                        
                      />

                  </Field>
                )}

                {/* GRADIENT */}
                {fillMode === "gradient" && (
                  <>
                    <div style={styles.inlineRow}>
                      <Field label="C1">
                          <ColorPopup
                            color={gradientColor1}
                            onChange={(gradientColor1) => setGradientColor1(gradientColor1)}                                                        
                          />
                      </Field>


                      <Field label="C2">
                          <ColorPopup
                            color={gradientColor2}
                            onChange={(gradientColor2) => setGradientColor2(gradientColor2)}                                                      
                          />

                      </Field>
                    </div>

                    <Field label="Angle">
                      <input
                        type="number"
                        min="0"
                        max="360"
                        value={gradientAngle}
                        onChange={(e) => setGradientAngle(e.target.value)}
                      />
                    </Field>
                  </>
                )}

                {/* Opacity */}
                {/*
                <Field label="Opacity">
                  <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    value={alpha}
                    onChange={(e) => setAlpha(e.target.value)}
                  />
                  <span>{alpha}</span>
                </Field>

                {backgroundAlphaSupported && (
                  <Field label="Img Opacity">
                    <input
                      type="range"
                      min="0"
                      max="1"
                      step="0.01"
                      value={bAlpha}
                      onChange={(e) => setBAlpha(e.target.value)}
                    />
                    <span>{bAlpha}</span>
                  </Field>
                )}
                */}
              </>
            )}

          </Section>


          {/* Corners Section */}
          {supportsCorners && (
            <Section title="Corners">

              <div style={styles.inlineRow}>
                <Corner label="TL" value={cornerTL} setValue={setCornerTL} />
                <Corner label="TR" value={cornerTR} setValue={setCornerTR} />
              </div>

              <div style={styles.inlineRow}>
                <Corner label="BL" value={cornerBL} setValue={setCornerBL} />
                <Corner label="BR" value={cornerBR} setValue={setCornerBR} />
              </div>

            </Section>
          )}

        <div style={styles.actions}>
          <button onClick={handleSave}>Save</button>
          <button onClick={onClose}>Cancel</button>
        </div>

      </div>
    </div>
  );
};


/* ---------- Reusable UI Components ---------- */

const Section = ({ title, children }) => (
  <div style={styles.section}>
    <h3 style={styles.sectionTitle}>{title}</h3>
    {children}
  </div>
);

const Field = ({ label, children }) => (
  <div style={styles.field}>
    <label style={styles.label}>{label}</label>
    {children}
  </div>
);

const Checkbox = ({ label, value, onChange }) => (
  <label style={styles.checkbox}>
    <input type="checkbox" checked={value} onChange={onChange} />
    {label}
  </label>
);

const Corner = ({ label, value, setValue }) => (
  <Field label={label}>
    <input
      type="range"
      min="0"
      max="100"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      style={{ width: "100%" }}
    />
    <span>{value}</span>
  </Field>
);


/* ---------- Styles ---------- */

const styles = {

  inlineRow: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8
  },

  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999999
  },

  dialog: {
    width: 340,
    background: "white",
    padding: 20,
    borderRadius: 8,
    boxShadow: "0 3px 10px rgba(0,0,0,0.15)"
  },

  section: {
    marginTop: 15
  },

  sectionTitle: {
    marginBottom: 6
  },

  field: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8
  },

  label: {
    width: 90
  },

  checkbox: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginBottom: 8
  },

  actions: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 20
  },

  input: {
    display: "block",
    width: "100%",
    padding: "6px 10px",
    marginTop: "5px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  labelFont: { display: "block", marginBottom: "15px", fontSize: "14px" },

};

export default SettingsDialog;
